import React, { Component } from "react";
import AppDynamicFilterModal from "../../../../partials/AppDynamicFilterModal";

export class MyRequestSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: {
        limit: 10,
        order_by: "updatedAt",
        order_direction: "DESC",
        page: 1,
      },
      openDrawer: false,
    };
    this.adminfields = [
      {
        name: "name",
        label: "Connector Name",
        placeholder: "Connector Name",
      },
      {
        name: "monthYear",
        label: "Month",
        type: "month",
        placeholder: "Month",
      },
    ];
    this.overallfields = [
      {
        name: "status",
        label: "Status",
        type: "select",
        options: _enum.ADMIN_KYC_REQUEST_STATUS,
        placeholder: "Status",
      },
      {
        name: "date",
        label: "Date",
        type: "date",
        placeholder: "Date",
      },
    ];
  }

  toggleDrawer = () => {
    this.setState((prev) => ({ openDrawer: !prev.openDrawer }));
  };

  closeDrawer = () => {
    this.setState({ openDrawer: false });
  };

  onSearch = (formData) => {
    let data = Object.filter(formData, (val) => val);
    const months = {
      Jan: "01",
      Feb: "02",
      Mar: "03",
      Apr: "04",
      May: "05",
      Jun: "06",
      Jul: "07",
      Aug: "08",
      Sep: "09",
      Oct: "10",
      Nov: "11",
      Dec: "12",
    };
    if (data?.monthYear) {
      let inputVal = data?.monthYear;
      const [month, year] = inputVal.split("-");
      const output = `${year}-${months[month]}`;
      data = {
        ...data,
        monthYear: output,
      };
    }
    this.props.onSearch && this.props.onSearch(data, false);
  };

  onReset = (formData, reset) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, reset);
  };

  render() {
    let { isAdmin } = this.props;
    let { openDrawer } = this.state;
    return (
      <div className="d-flex align-items-center justify-content-end mb-4">
        <button
          type="button"
          className="btn filter_modal_btn"
          onClick={(...args) => this.toggleDrawer(...args)}
        >
          <i class="fa-solid fa-filter me-2"></i>
          <span>Filters</span>
        </button>
        <AppDynamicFilterModal
          open={openDrawer}
          onClose={this.closeDrawer}
          fields={isAdmin ? this.adminfields : this.overallfields}
          onSearch={this.onSearch}
          onReset={this.onReset}
        />
      </div>
    );
  }
}

export default constore(MyRequestSearch);
